import { trpc } from '@/lib/trpc';
import { useNavigate } from 'react-router-dom';

export default function MyCoursesPage() {
  const nav = useNavigate();

  const { data: purchases = [], isLoading } = trpc.purchases.getUserPurchases.useQuery();

  if (isLoading) return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-yellow-400 border-t-transparent
                      rounded-full animate-spin" />
    </div>
  );

  return (
    <div className="min-h-screen bg-black py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <span className="mp-pill">My Library</span>
          <h1 className="text-4xl font-bold text-white mt-4 mb-2 tracking-tight">Courses</h1>
          <p className="text-[#E4E4E7] text-lg">Continue where you left off.</p>
        </div>

        {purchases.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-5xl mb-4">🎓</p>
            <p className="text-[#52525B] text-lg mb-6">No purchases yet.</p>
            <button onClick={() => nav('/courses')}
                    className="mp-btn mp-btn-primary px-6 py-3 text-base">
              Browse Courses
            </button>
          </div>
        ) : (
          <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
            {purchases.map(p => (
              <div key={p.id}
                   className="mp-card min-w-[270px] flex-shrink-0
                              hover:shadow-[0_8px_32px_rgba(0,0,0,0.4)]
                              hover:-translate-y-1 transition-all duration-300">
                <div className="w-full h-[120px] bg-gradient-to-br from-yellow-400/20 to-yellow-400/5
                                rounded-t-3xl flex items-center justify-center overflow-hidden">
                  {(p.course as any).imageUrl ? (
                    <img
                      src={(p.course as any).imageUrl}
                      alt={p.course.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  ) : (
                    <span className="text-5xl font-bold text-yellow-400 select-none">
                      {p.course.title[0]}
                    </span>
                  )}
                </div>
                <div className="p-4">
                  <span className="inline-flex items-center gap-1 bg-green-500/10 text-green-400
                                   text-[11px] font-semibold px-2 py-0.5 rounded-full mb-2">
                    ✓ Purchased
                  </span>
                  <h3 className="text-[#E4E4E7] font-semibold text-sm mt-1 mb-1 leading-snug">
                    {p.course.title}
                  </h3>
                  <p className="text-[#71717A] text-xs mb-4">
                    {p.course.sections.length} modules · paid {p.pricePaid} KD
                  </p>
                  <button
                    onClick={() => nav(`/courses/${p.courseId}/watch`)}
                    className="mp-btn mp-btn-primary w-full py-2.5 rounded-2xl text-sm"
                  >
                    ▶ Watch
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
